<template>
  <div class="sp-template">
    <div class="h-title">司机提货</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form inline class="demo-form-inline" size="small">
          <el-form-item label="订单号">
            <el-input v-model.lazy="number" placeholder="订单号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-if="in_configs(41301)" type="primary" @click="onSubmit">搜 索</el-button>
            <el-button v-if="in_configs(41302)" size="small" class="btn-cyan" @click="$router.push('/phonepickup')">微信提货</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="tableData" border stripe>
        <el-table-column prop="test" label="订单号" width="200"></el-table-column>
        <el-table-column prop="adress" label="地址" show-overflow-tooltip></el-table-column>
        <el-table-column prop="date" label="预约时间" width="200"></el-table-column>
        <el-table-column prop="test" label="箱数" width="80"></el-table-column>
        <el-table-column prop="test" label="电话" width="200"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button v-if="in_configs(41303)" size="mini" type="text" @click="dialogFormVisible = true">提货</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="400">
      </el-pagination>
    </el-card>
    <!-- Form -->
    <el-dialog title="提货" :visible.sync="dialogFormVisible" width="450px">
      <el-form :model="form" size="small" :label-width="formLabelWidth" label-position="left">
        <el-form-item label="订单号">sp121212</el-form-item>
        <el-form-item label="应  收">10箱</el-form-item>
        <el-form-item label="实收(箱)">
          <el-input v-model.lazy="form.test"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      number: "",
      tableData: [
        {
          test: "666",
          date: '2018-05-10 12:00:00',
          adress:
            "123232323232323232323232323232323232323232323232323232323232323232323232323232323232321321"
        }
      ],
      formLabelWidth: "80px",
      dialogFormVisible: false,
      form: { test: "" },
      multipleSelection: [],
      currentPage: 2 //分页
    };
  },
  components: {},
  created() {},
  computed: {},
  methods: {
    //搜索
    onSubmit() {
      console.log("搜索");
    },
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/orderOperation/driverpickup.vue